<template>
  <div>
    <demo-login-modal />
    <!-- <HotelHero class="hotellisthero"></HotelHero> -->
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex py-5">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">Your Orders</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="container">
        <section class="section">
          <div>
            <tabs fill class="flex-column flex-md-row">
              <card shadow>
                <tab-pane title="Upcoming Bookings">
                  <p v-if="orders.length < 1" class="description">
                    <strong>Oops! You are yet to book hotels with us. </strong>
                    <RouterLink class="btn btn-primary" to="/"
                      >Start Searching Hotels Now</RouterLink
                    >
                  </p>

                  <div v-if="orders.length > 0">
                    <div v-for="(order, index) in orders" v-bind:key="index">
                      <card
                        class="mt-3"
                        v-if="order.status_id != '5' && order.status_id != '1'"
                        shadow
                      >
                        <RouterLink :to="'/orderdone?orderid=' + order.id">
                          <div class="row">
                            <div class="col-md-2">
                              <img
                                src="img/hotelimg.png"
                                width="90%"
                                class="img-circle img"
                              />
                            </div>
                            <div class="col-md-4">
                              <h5>{{ order.subject }}</h5>
                              <p>
                                OrderID: <strong> {{ order.longid }} </strong>
                              </p>
                              <p>
                                Order Date: <strong> {{ order.date }} </strong>
                              </p>
                            </div>
                            <div class="col-md-3">
                              <p>
                                Discount:
                                <strong> {{ order.discount }} </strong>
                              </p>
                              <h6>
                                Total:
                                <strong>
                                  <span>&#8377;</span> {{ order.total }}
                                </strong>
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <p>Status:</p>
                              <h6><strong> </strong></h6>
                              <h6 v-if="order.status == 'sent'">
                                <strong class="alert alert-info">
                                  Awaiting Approval
                                </strong>
                              </h6>
                              <h6 v-if="order.status == 'accepted'">
                                <strong class="alert alert-success">
                                  Confirmed
                                </strong>
                              </h6>
                              <h6 v-if="order.status == 'declined'">
                                <strong class="alert alert-warning">
                                  Rejected / Cancelled
                                </strong>
                              </h6>
                              <h6
                                v-if="
                                  order.status != 'declined' &&
                                  order.status != 'accepted' &&
                                  order.status != 'sent'
                                "
                              >
                                <strong class="alert alert-warning">
                                  {{ order.status }}
                                </strong>
                              </h6>
                            </div>
                          </div>
                        </RouterLink>
                      </card>
                    </div>
                  </div>
                </tab-pane>

                <tab-pane title="Cancelled Bookings">
                  <p v-if="orders.length < 1" class="description">
                    <strong>Oops! You are yet to book hotels with us. </strong>
                    <RouterLink class="btn btn-primary" to="/"
                      >Start Searching Hotels Now</RouterLink
                    >
                  </p>

                  <div v-if="orders.length > 0">
                    <div v-for="(order, index) in orders" v-bind:key="index">
                      <card class="mt-3" v-if="order.status_id == '5'" shadow>
                        <RouterLink :to="'/orderdone?orderid=' + order.orderid">
                          <div class="row">
                            <div class="col-md-2">
                              <img
                                src="img/hotelimg.png"
                                width="90%"
                                class="img-circle img"
                              />
                            </div>
                            <div class="col-md-4">
                              <h5>{{ order.subject }}</h5>
                              <p>
                                OrderID: <strong> {{ order.longid }} </strong>
                              </p>
                              <p>
                                Order Date: <strong> {{ order.date }} </strong>
                              </p>
                            </div>
                            <div class="col-md-3">
                              <p>
                                Discount:
                                <strong> {{ order.discount }} </strong>
                              </p>
                              <h6>
                                Total:
                                <strong>
                                  <span>&#8377;</span> {{ order.total }}
                                </strong>
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <p>Status:</p>
                              <h6><strong> </strong></h6>
                              <h6 v-if="order.status == 'sent'">
                                <strong class="alert alert-info">
                                  Awaiting Approval
                                </strong>
                              </h6>
                              <h6 v-if="order.status == 'accepted'">
                                <strong class="alert alert-success">
                                  Confirmed
                                </strong>
                              </h6>
                              <h6 v-if="order.status == 'declined'">
                                <strong class="alert alert-warning">
                                  Rejected / Cancelled
                                </strong>
                              </h6>
                              <h6
                                v-if="
                                  order.status != 'declined' &&
                                  order.status != 'accepted' &&
                                  order.status != 'sent'
                                "
                              >
                                <strong class="alert alert-warning">
                                  {{ order.status }}
                                </strong>
                              </h6>
                            </div>
                          </div>
                        </RouterLink>
                      </card>
                    </div>
                  </div>
                </tab-pane>

                <tab-pane title="Completed Bookings">
                  <p v-if="orders.length < 1" class="description">
                    <strong>Oops! You are yet to book hotels with us. </strong>
                    <RouterLink class="btn btn-primary" to="/"
                      >Start Searching Hotels Now</RouterLink
                    >
                  </p>

                  <div v-if="orders.length > 0">
                    <div v-for="(order, index) in orders" v-bind:key="index">
                      <card class="mt-3" v-if="order.status_id == '6'" shadow>
                        <RouterLink :to="'/orderdone?orderid=' + order.orderid">
                          <div class="row" >
                            <div class="col-md-2">
                              <img
                                src="img/hotelimg.png"
                                width="90%"
                                class="img-circle img"
                              />
                            </div>
                            <div class="col-md-4">
                              <h5>{{ order.subject }}</h5>
                              <p>
                                OrderID: <strong> {{ order.longid }} </strong>
                              </p>
                              <p>
                                Order Date: <strong> {{ order.date }} </strong>
                              </p>
                            </div>
                            <div class="col-md-3">
                              <p>
                                Discount:
                                <strong> {{ order.discount }} </strong>
                              </p>
                              <h6>
                                Total:
                                <strong>
                                  <span>&#8377;</span> {{ order.total }}
                                </strong>
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <p>Status:</p>
                              <h6><strong> </strong></h6>
                              <h6 v-if="order.status == 'sent'">
                                <strong class="alert alert-info">
                                  Awaiting Approval
                                </strong>
                              </h6>
                              <h6 v-if="order.status == 'accepted'">
                                <strong class="alert alert-success">
                                  Confirmed
                                </strong>
                              </h6>
                              <h6 v-if="order.status == 'declined'">
                                <strong class="alert alert-warning">
                                  Rejected / Cancelled
                                </strong>
                              </h6>
                              <h6
                                v-if="
                                  order.status != 'declined' &&
                                  order.status != 'accepted' &&
                                  order.status != 'sent'
                                "
                              >
                                <strong class="alert alert-warning">
                                  {{ order.status }}
                                </strong>
                              </h6>
                            </div>
                          </div>
                        </RouterLink>
                      </card>
                    </div>
                  </div>
                </tab-pane>
              </card>
            </tabs>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import Tabs from "../components/Tabs/Tabs";
import TabPane from "../components/Tabs/TabPane";
import axios from "axios";
import { APIURLS } from "../api/constants";
import moment from "moment";
//import DemoCheckoutModal from "../modals/modal_checkout";
import DemoLoginModal from "../views/modals/modal_login";

export default {
  components: {
    Tabs,
    TabPane,
    DemoLoginModal,
  },
  data() {
    return {
      orders: [],
      showError: false,
      errorString: "",
    };
  },
  methods: {
    getOrders() {
      var isLoggedIn = localStorage.getItem("loggedIn");
      if (isLoggedIn == "yes") {
        var cid = localStorage.getItem("customer_id");
        var formData = new FormData();
        formData.append("userid", cid);
        axios.post(APIURLS.GET_ORDERS, formData).then((response) => {
          this.showLoading = false;
          var data = response.data;
          if (data.length > 0) {
            // this.showSuccess = true;
            this.orders = data;
            // console.log("ORDERs:" + this.orders.length);
            //this.$router.push({ path: 'orderdone', query: { orderid: data.id } });
          } else {
            this.errorString = "Orders are not available for your account";
            this.showError = true;
          }
          //console.log(response);
        });
      } else {
        this.errorString = data.message;
        this.showError = true;
      }
    },
  },
  created() {
    this.getOrders();
  },
};
</script>
<style scoped>
</style>